import { render } from "./CreateFromDependents.vue?vue&type=template&id=585dbff5&ts=true"
import script from "./CreateFromDependents.vue?vue&type=script&lang=ts"
export * from "./CreateFromDependents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__